export const TABLE_CONFIG = {
  // 固定列の設定
  FIXED_COLUMNS: [
    // Labelはi18nで管理
    { id: "requestedFor", index: 0 },
    { id: "progress", index: 1 },
  ],
  // 固定列の数
  FIXED_COLUMN_COUNT: 2,
  // 詳細ページへのURLパターン
  DETAIL_URL_PATTERN:
    "/:coreType/operation-packages/:operationPackageId/patterns/:patternId/instances/:id",
} as const;

// カラムインデックスに関するヘルパー関数
export const getDetailUrlWithParams = (
  coreType: "labor-core" | "contractor-core" | "ga-operation-core",
  operationPackageId: string,
  patternId: string,
  instanceId: string,
): string => {
  return TABLE_CONFIG.DETAIL_URL_PATTERN.replace(":coreType", coreType)
    .replace(":operationPackageId", operationPackageId)
    .replace(":patternId", patternId)
    .replace(":id", instanceId);
};
